export const types = {
  SET_NETWORKS: 'SET_NETWORKS',
};
